module.exports = __webpack_public_path__ + "static/media/676224040.01ec2671.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/AlliedHealth/676224040.jpg
// module id = 637
// module chunks = 0